import { useMutation, useQueryClient } from '@tanstack/react-query'
import { ExtendableMutationOptions } from 'shared/api/api.types'

import { authApi } from '../..'
import { onLoginSuccess } from '../../utils/onLoginSuccess'
import {
  LoginViaIntermediateTokenRequest,
  LoginViaIntermediateTokenResponse
} from './loginViaIntermediateToken.types'

export const loginViaIntermediateToken = async (
  request: LoginViaIntermediateTokenRequest
) => {
  const response = await authApi.post<LoginViaIntermediateTokenResponse>(
    '/login-via-intermediate-token',
    request
  )
  return response.data
}

export const useLoginViaIntermediateTokenMutation = (
  options?: ExtendableMutationOptions<
    LoginViaIntermediateTokenResponse,
    LoginViaIntermediateTokenRequest
  > & {
    customRedirectRoute?: string
  }
) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: loginViaIntermediateToken,
    onSuccess: (data, ...args) => {
      onLoginSuccess(data, queryClient, false, options?.customRedirectRoute)
      options?.onSuccess?.(data, ...args)
    },
    ...options
  })
}
